import { event } from 'vue-gtag'
import { useRoute } from 'vue-router'

export function useGA() {
  function push(name: string, params = {}) {
    event(name, {
      event_category: '',
      event_action: '',
      event_value: '',
      source: 'web',
      campaign: 'ga-event',
      medium: 'true',
      page_title: '',
      page_location: window.location.href,
      page_referrer: document.referrer,
      ga_session_number: '',
      ga_session_id: '',
      link_url: window.location.href,
      link_domain: '',
      link_classes: '',
      outbound: '',
      link_name: '',
      ...params,
    })
  }

  const route = useRoute()

  function pageView(title: string, path?: string, params = {}) {
    push('page_view', {
      page_title: title,
      page_path: path || route.path,
      page_location: window.location.href,
      ...params,
    })
  }

  function click(params = {}) {
    push('BELAJAR_ID_ACTIVITY', {
      event_category: 'activity',
      event_action: 'click',
      activity_type: 'activity',
      action: 'click',
      ...params,
    })
  }

  function clickLink(linkName: string, params = {}) {
    click({
      event_label: 'click_link',
      event_value: linkName,
      activity_type: 'click_link',
      link_name: linkName,
      ...params,
    })
  }

  function clickButton(linkName: string, params = {}) {
    click({
      event_label: 'click_button',
      event_value: linkName,
      activity_type: 'click_button',
      link_name: linkName,
      ...params,
    })
  }

  function trackActivity(params = {}) {
    push('BELAJAR_ID_ACTIVITY', params)
  }

  return { push, click, clickLink, clickButton, pageView, trackActivity }
}
